import styled from 'styled-components';

import { BudgetMessage } from '../../../../types/BudgetMessage';
import { Text } from '../../../cdl/Text/Text';
import { formatMoney } from '../../../common/helpers/formatMoney.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { theme } from '../../../common/ui/theme';

interface CaptionColorProps {
    color?: string;
}

const CaptionColor = styled(Box)<CaptionColorProps>(
    {
        borderRadius: 4,
        width: '24px',
        height: '24px',
        marginRight: 16,
    },

    (props) => {
        if (props.color) {
            return {
                backgroundColor: props.color,
            };
        }
    }
);

interface BudgetCaptionProps {
    budgetData: BudgetMessage;
}

export const BudgetCaption = ({ budgetData }: BudgetCaptionProps) => {
    return (
        <Box display="grid" gridTemplateColumns="minmax(0, 2fr) minmax(0, 1fr)" gap={16}>
            <Box display="flex" alignItems="center">
                <CaptionColor color={theme.colors.background.inset} />
                <Text weight="semi" size={14}>
                    {translate('budgets.budgetAvailable')}
                </Text>
            </Box>

            <Box display="flex" alignItems="center" justifyContent="flex-end">
                <Text
                    textAlign="right"
                    size={14}
                    weight="semi"
                    color={budgetData.remainingBudget.amount < 0 ? 'negative.foreground' : undefined}
                >
                    {formatMoney({
                        value: budgetData.remainingBudget.amount,
                        currency: budgetData.remainingBudget.currency,
                    })}
                </Text>
            </Box>

            <Box display="flex" alignItems="center">
                <CaptionColor color={theme.colors.accent.emphasis} />
                <Text weight="semi" size={14}>
                    {translate('budgets.budgetSpent')}
                </Text>
            </Box>

            <Box display="flex" alignItems="center" justifyContent="flex-end">
                <Text size={14} weight="semi" textAlign="right">
                    {formatMoney({
                        value: budgetData.spentBudget.amount,
                        currency: budgetData.spentBudget.currency,
                    })}
                </Text>
            </Box>
        </Box>
    );
};
